// extracted by mini-css-extract-plugin
export default {"tabs":"AreaTabs_tabs__UZOCh"};